<template>
  <!-- MODAL Lighting -->
  <b-modal
    id="addDevice"
    title="เพิ่มอุปกรณ์"
    size="lg"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @shown="modalShown"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <validation-observer ref="simpleRules">
      <b-row>
        <b-col
          md="12"
          lg="2"
          class="mb-1"
        >
          <!-- input text with help -->
          <b-form-group
            label="เสาที่"
          >
            <validation-provider
              #default="{ errors }"
              name="Pole"
              rules="required"
            >
              <b-form-input
                v-model="addData.pole"
                :state="errors.length > 0 ? false:null"
                required
                type="text"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          lg="2"
          class="mb-1"
        >

          <!-- basic -->
          <b-form-group
            label="รหัสอุปกรณ์"
          >
            <validation-provider
              #default="{ errors }"
              name="devid"
              rules="required"
            >
              <b-form-input
                v-model="addData.devid"
                type="text"
                :state="errors.length > 0 ? false:null"
                required
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          xl="4"
          class="mb-1"
        >
          <!-- basic -->
          <b-form-group
            label="ชื่ออุปกรณ์"
          >
            <validation-provider
              #default="{ errors }"
              name="Name"
              rules="required"
            >
              <b-form-input
                v-model="addData.devdesc"
                type="text"
                :state="errors.length > 0 ? false:null"
                required
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          md="12"
          lg="4"
          class="mb-1"
        >
          <!-- input text with help -->
          <b-form-group
            label="ประเภทอุปกรณ์"
          >
            <validation-provider
              #default="{ errors }"
              name="devtype"
              rules="required"
            >
              <v-select
                v-model="addData.devtype"
                class="style-chooser"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="devtype"
                :options="itemType"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          xl="6"
          class="mb-1"
        >
          <!-- input text with help -->
          <b-form-group
            label="ละติจูด"
          >
            <validation-provider
              #default="{ errors }"
              name="Latitude"
              rules="required"
            >
              <b-form-input
                v-model="addData.latitude"
                type="text"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          xl="6"
          class="mb-1"
        >
          <!-- input text with help -->
          <b-form-group
            label="ลองจิจูด"
          >
            <validation-provider
              #default="{ errors }"
              name="Longitude"
              rules="required"
            >
              <b-form-input
                v-model="addData.longitude"
                type="text"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          lg="12"
          md="12"
        >
          <div style="height:500px">
            <l-map
              ref="mymap1"
              :zoom="zoom"
              :center="center"
              @click="addMarker"
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              />
              <l-marker
                v-for="(marker, index) in markers"
                ref="marker"
                :key="index"
                :lat-lng="marker"
              />
              <l-marker
                v-for="(marker1, index) in markersdevice"
                :key="'marker1'+index"
                :ref="'marker1'+index"
                :lat-lng="[marker1.latitude, marker1.longitude]"
                :options="{ autoClose: false, closeOnClick: false }"
              >
                <l-icon
                  :icon-size="[28, 40]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/Markerlighting.svg')"
                />
                <l-popup
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">{{ marker1.pole }}</span>
                  </div>
                </l-popup>
              </l-marker>
            </l-map>
          </div>
        </b-col>
      </b-row>
    </validation-observer>

  </b-modal>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'
import {
  BRow, BCol, BFormInput, BFormGroup,
//   BLink,
} from 'bootstrap-vue'
/* eslint-disable global-require */
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import { Icon } from 'leaflet'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import 'leaflet/dist/leaflet.css'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    vSelect,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '',
      zoom: '',
      center: [],
      markers: [],
      markersdevice: [],
      addData: {
        devid: '',
        semid: '',
        imei: '',
        pole: '',
        wid: '',
        latitude: '',
        longitude: '',
        devtype: '',
        devdesc: '',
      },
      itemType: [],
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getCenterSem()
  },
  mounted() {
  },
  methods: {
    addMarker(evt) {
      if (this.markers.length > 0) {
        this.markers = []
      }
      this.markers.push(evt.latlng)
      this.addData.latitude = evt.latlng.lat
      this.addData.longitude = evt.latlng.lng
    },
    getCenterSem() {
      axios
        .post('/waySEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center.splice(0)
          this.zoom = 17
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMarkerSemDevice() {
      axios
        .post('/markerSEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.markersdevice = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    modalShown() {
      this.checkDeviceSem()
      this.dropdown()
      this.getMarkerSemDevice()
      this.$refs.mymap1.mapObject.invalidateSize()
    },
    dropdown() {
      axios
        .post('/dropdownDevtype')
        .then(response => {
          this.item = response.data
          this.item.forEach(value => {
            this.itemType.push(value.devtype)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    checkDeviceSem() {
      axios
        .post('/checkDeviceSem', { wid: this.$route.query.wid, controller_id: 1 })
        .then(response => {
          this.addData.semid = response.data[0].id
          this.addData.imei = response.data[0].imei
          console.log(this.addData.imei)
        })
        .catch(error => {
          console.log(error)
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success) {
          // eslint-disable-next-line
          return
        }
        this.addDevice()
        this.$nextTick(() => {
          this.$bvModal.hide('addDevice')
        })
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
    addDevice() {
      this.addData.wid = this.$route.query.wid
      const display = this.addData
      console.log(display)
      axios
        .post('/addDevice', display)
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">บันทึกสำเร็จ</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.$emit('fetch')
          this.resetModal()
        })
        .catch(error => {
          console.log(error)
          this.$swal({
            icon: 'error',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          })
        })
    },
    resetModal() {
      this.addData.devid = ''
      this.addData.pole = ''
      this.addData.wid = ''
      this.addData.latitude = ''
      this.addData.longitude = ''
      this.addData.devtype = ''
      this.addData.devdesc = ''
      this.markers.splice(0)
    },
  },
}
</script>

<style lang="scss">
.vue2leaflet-map{
  &.leaflet-container{
    height: 500px;
    width: 96%;
  }
}
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle
{
  background: #242424;
  padding: 0px 0px 6px;
  border: 1px solid;
  color: #404656;
  text-transform: lowercase;
  font-variant: small-caps;
}

.style-chooser .vs__clear,
.style-chooser .vs__selected,
.style-chooser .vs__open-indicator {
  fill: #ffffff;
  color:#ffffff;
  font-size: 16px;
}
</style>
